import React from 'react'
import { ROUTES } from 'constants/routes'
import { Text } from 'hocs/localization'
import Button from 'elements/Button'
import Heading from 'elements/Heading'
import * as styles from './Question.scss'

interface IProps {
  t: Text,
}

const Question: React.FC<IProps> = ({ t, history }) => (
  <section className={styles.root}>
    <div className='container'>
      <div className='row'>
        <div className='col-md-12'>
          <Heading size={2}>{t('header')}</Heading>
          <div className={styles.button}>
            <Button onClick={() => history.push(ROUTES.home.contactUs)} fluid>{t('contactUsButton')}</Button>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default Question
